// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { ToolbarItem } from '@progress/kendo-vue-buttons';
import { getDefaultSlots } from '@progress/kendo-vue-common';
import { messages, today, previousTitle, nextTitle } from '../../../messages/main';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { caretAltLeftIcon, caretAltRightIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
var SchedulerNavigationVue2 = {
  name: 'KendoSchedulerNavigation',
  props: {},
  inject: {
    ks: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    this.localization = provideLocalizationService(this);
    var todayText = this.localization.toLanguageString(today, messages[today]);
    var previousText = this.localization.toLanguageString(previousTitle, messages[previousTitle]);
    var nextText = this.localization.toLanguageString(nextTitle, messages[nextTitle]);
    return (
      // @ts-ignore  function children
      h(ToolbarItem, this.v3 ? function () {
        return [
        // @ts-ignore  function children
        h(ButtonGroup, {
          "class": "k-scheduler-navigation"
        }, _this.v3 ? function () {
          return [
          // @ts-ignore  function children
          h(Button, {
            role: "button",
            attrs: _this.v3 ? undefined : {
              role: "button",
              tabIndex: -1,
              title: todayText,
              "aria-label": todayText
            },
            "class": "k-nav-today",
            tabIndex: -1,
            title: todayText,
            "aria-label": todayText,
            onClick: _this.handleTodayClick,
            on: _this.v3 ? undefined : {
              "click": _this.handleTodayClick
            }
          }, _this.v3 ? function () {
            return [todayText];
          } : [todayText]),
          // @ts-ignore  function children
          h(Button, {
            role: "button",
            attrs: _this.v3 ? undefined : {
              role: "button",
              tabIndex: -1,
              icon: 'caret-alt-left',
              svgIcon: caretAltLeftIcon,
              title: previousText,
              "aria-label": previousText
            },
            tabIndex: -1,
            "class": "k-button-icon k-nav-prev",
            icon: 'caret-alt-left',
            svgIcon: caretAltLeftIcon,
            title: previousText,
            "aria-label": previousText,
            onClick: _this.handlePrevClick,
            on: _this.v3 ? undefined : {
              "click": _this.handlePrevClick
            }
          }),
          // @ts-ignore  function children
          h(Button, {
            role: "button",
            attrs: _this.v3 ? undefined : {
              role: "button",
              tabIndex: -1,
              icon: 'caret-alt-right',
              svgIcon: caretAltRightIcon,
              title: nextText,
              "aria-label": nextText
            },
            tabIndex: -1,
            "class": "k-button-icon k-nav-next",
            icon: 'caret-alt-right',
            svgIcon: caretAltRightIcon,
            title: nextText,
            "aria-label": nextText,
            onClick: _this.handleNextClick,
            on: _this.v3 ? undefined : {
              "click": _this.handleNextClick
            }
          })];
        } : [h(Button, {
          role: "button",
          attrs: _this.v3 ? undefined : {
            role: "button",
            tabIndex: -1,
            title: todayText,
            "aria-label": todayText
          },
          "class": "k-nav-today",
          tabIndex: -1,
          title: todayText,
          "aria-label": todayText,
          onClick: _this.handleTodayClick,
          on: _this.v3 ? undefined : {
            "click": _this.handleTodayClick
          }
        }, _this.v3 ? function () {
          return [todayText];
        } : [todayText]), h(Button, {
          role: "button",
          attrs: _this.v3 ? undefined : {
            role: "button",
            tabIndex: -1,
            icon: 'caret-alt-left',
            svgIcon: caretAltLeftIcon,
            title: previousText,
            "aria-label": previousText
          },
          tabIndex: -1,
          "class": "k-button-icon k-nav-prev",
          icon: 'caret-alt-left',
          svgIcon: caretAltLeftIcon,
          title: previousText,
          "aria-label": previousText,
          onClick: _this.handlePrevClick,
          on: _this.v3 ? undefined : {
            "click": _this.handlePrevClick
          }
        }), h(Button, {
          role: "button",
          attrs: _this.v3 ? undefined : {
            role: "button",
            tabIndex: -1,
            icon: 'caret-alt-right',
            svgIcon: caretAltRightIcon,
            title: nextText,
            "aria-label": nextText
          },
          tabIndex: -1,
          "class": "k-button-icon k-nav-next",
          icon: 'caret-alt-right',
          svgIcon: caretAltRightIcon,
          title: nextText,
          "aria-label": nextText,
          onClick: _this.handleNextClick,
          on: _this.v3 ? undefined : {
            "click": _this.handleNextClick
          }
        })])];
      } : [h(ButtonGroup, {
        "class": "k-scheduler-navigation"
      }, _this.v3 ? function () {
        return [h(Button, {
          role: "button",
          attrs: _this.v3 ? undefined : {
            role: "button",
            tabIndex: -1,
            title: todayText,
            "aria-label": todayText
          },
          "class": "k-nav-today",
          tabIndex: -1,
          title: todayText,
          "aria-label": todayText,
          onClick: _this.handleTodayClick,
          on: _this.v3 ? undefined : {
            "click": _this.handleTodayClick
          }
        }, _this.v3 ? function () {
          return [todayText];
        } : [todayText]), h(Button, {
          role: "button",
          attrs: _this.v3 ? undefined : {
            role: "button",
            tabIndex: -1,
            icon: 'caret-alt-left',
            svgIcon: caretAltLeftIcon,
            title: previousText,
            "aria-label": previousText
          },
          tabIndex: -1,
          "class": "k-button-icon k-nav-prev",
          icon: 'caret-alt-left',
          svgIcon: caretAltLeftIcon,
          title: previousText,
          "aria-label": previousText,
          onClick: _this.handlePrevClick,
          on: _this.v3 ? undefined : {
            "click": _this.handlePrevClick
          }
        }), h(Button, {
          role: "button",
          attrs: _this.v3 ? undefined : {
            role: "button",
            tabIndex: -1,
            icon: 'caret-alt-right',
            svgIcon: caretAltRightIcon,
            title: nextText,
            "aria-label": nextText
          },
          tabIndex: -1,
          "class": "k-button-icon k-nav-next",
          icon: 'caret-alt-right',
          svgIcon: caretAltRightIcon,
          title: nextText,
          "aria-label": nextText,
          onClick: _this.handleNextClick,
          on: _this.v3 ? undefined : {
            "click": _this.handleNextClick
          }
        })];
      } : [h(Button, {
        role: "button",
        attrs: _this.v3 ? undefined : {
          role: "button",
          tabIndex: -1,
          title: todayText,
          "aria-label": todayText
        },
        "class": "k-nav-today",
        tabIndex: -1,
        title: todayText,
        "aria-label": todayText,
        onClick: _this.handleTodayClick,
        on: _this.v3 ? undefined : {
          "click": _this.handleTodayClick
        }
      }, _this.v3 ? function () {
        return [todayText];
      } : [todayText]), h(Button, {
        role: "button",
        attrs: _this.v3 ? undefined : {
          role: "button",
          tabIndex: -1,
          icon: 'caret-alt-left',
          svgIcon: caretAltLeftIcon,
          title: previousText,
          "aria-label": previousText
        },
        tabIndex: -1,
        "class": "k-button-icon k-nav-prev",
        icon: 'caret-alt-left',
        svgIcon: caretAltLeftIcon,
        title: previousText,
        "aria-label": previousText,
        onClick: _this.handlePrevClick,
        on: _this.v3 ? undefined : {
          "click": _this.handlePrevClick
        }
      }), h(Button, {
        role: "button",
        attrs: _this.v3 ? undefined : {
          role: "button",
          tabIndex: -1,
          icon: 'caret-alt-right',
          svgIcon: caretAltRightIcon,
          title: nextText,
          "aria-label": nextText
        },
        tabIndex: -1,
        "class": "k-button-icon k-nav-next",
        icon: 'caret-alt-right',
        svgIcon: caretAltRightIcon,
        title: nextText,
        "aria-label": nextText,
        onClick: _this.handleNextClick,
        on: _this.v3 ? undefined : {
          "click": _this.handleNextClick
        }
      })])])
    );
  },
  methods: {
    handleTodayClick: function handleTodayClick(e) {
      this.$emit('todayclick', e);
    },
    handlePrevClick: function handlePrevClick(e) {
      this.$emit('prevclick', e);
    },
    handleNextClick: function handleNextClick(e) {
      this.$emit('nextclick', e);
    }
  }
};
/**
 * @hidden
 */
var SchedulerNavigation = SchedulerNavigationVue2;
export { SchedulerNavigation, SchedulerNavigationVue2 };